import styled from 'styled-components';
import { device, typography } from '@/styles/helpers';

const COL_BACKGROUNDS = [
  '#1C1C1E',
  'linear-gradient(180deg, rgba(232, 233, 233, 0.4) 0%, rgba(253, 253, 251, 0.4) 37%, rgba(148, 151, 157, 0.4) 75%, rgba(197, 199, 204, 0.4) 100%)',
  'linear-gradient(180deg, rgba(251, 242, 174, 0.6) 0%, rgba(162, 104, 19, 0.6) 50%, rgba(217, 170, 86, 0.6) 100%)',
] as const;

export const ScComparisonTable = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) repeat(3, 1fr);
  gap: 4px;
  width: 100%;
`;

export const ScHeaderLabelCell = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  ${typography.body1bold};
  color: ${({ theme }) => theme.whiteColor};
`;

export const ScHeaderCell = styled.div<{ $colIndex: number }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  height: 100%;
  border-radius: 8px;
  background: ${({ $colIndex }) =>
    COL_BACKGROUNDS[$colIndex] ?? COL_BACKGROUNDS[0]};

  @media (${device.tablet}) {
    padding: 16px 12px;
    gap: 8px;
  }

  @media (${device.mobile}) {
    flex-direction: column;
  }
`;

export const ScHeaderTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (${device.tablet}) {
    gap: 4px;
  }

  @media (${device.mobile}) {
    order: 1;
    text-align: center;
  }
`;

export const ScContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ScHeaderTitle = styled.span`
  ${typography.headline3};
  color: ${({ theme }) => theme.whiteColor};
  text-transform: uppercase;
  @media (${device.mobile}) {
    text-align: center;
  }
`;

export const ScHeaderTitleSlider = styled.span`
  ${typography.headline3};
  color: ${({ theme }) => theme.whiteColor};
  text-transform: uppercase;

  @media (min-width: 320px) and (max-width: 359px) {
    text-align: center;
  }

  @media (${device.mobile}) {
    text-align: left;
  }
`;

export const ScHeaderSubTitle = styled.span`
  ${typography.body1regular};
  color: ${({ theme }) => theme.whiteColor};
`;

export const ScHeaderLevelLabel = styled.span`
  ${typography.body1regular};
  color: ${({ theme }) => theme.blackLightColor};
`;

export const ScHeaderBadge = styled.div`
  flex-shrink: 0;

  @media (${device.tablet}) {
    & .badge-img {
      width: 112px;
      height: 112px;
    }
  }

  @media (${device.mobile}) {
    order: -1;

    & .badge-img {
      width: 52px;
      height: 52px;
    }
  }
`;

export const ScSectionSpacer = styled.div`
  height: 12px;
`;

export const ScValueCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 12px 8px;
  text-align: center;
  background: #1c1c1e;
  border-radius: 8px;
  ${typography.body1regular};
  color: ${({ theme }) => theme.whiteColor};
`;
